import styled from 'styled-components';

export const Callout = styled('strong')`
  color: white;
  font-weight: normal;
  background-color: ${({ bgColor }) => bgColor};
`;
